import type { DrawerProps as MuiDrawerProps } from '@mui/material'
import { Box, Drawer as MuiDrawer, useMediaQuery, useTheme } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'

import { unit } from '@hcr/ui'

export type DrawerProps = PropsWithChildren &
  MuiDrawerProps & { paddingBottom?: string; paddingLeft?: string; paddingRight?: string; paddingTop?: string }

export const Drawer: FC<DrawerProps> = ({
  children,
  paddingTop,
  paddingLeft,
  paddingRight,
  paddingBottom,
  ...props
}) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <MuiDrawer {...props} ModalProps={{ disableScrollLock: isDesktop, closeAfterTransition: true }}>
      <Box
        paddingTop={paddingTop || unit(7)}
        paddingLeft={paddingLeft || unit(7)}
        paddingRight={paddingRight || unit(7)}
        paddingBottom={paddingBottom || unit(11)}
      >
        {children}
      </Box>
    </MuiDrawer>
  )
}
